import { api } from "../.."

// função para pesquisar as ordens
const ManagersOrdersService = async (number: number, costCenter: number, date: string, status: number, page: number, nameUser: string) => {

    const response = await api.get('managers/orders', {
        params: {
            number, costCenter, date, status, page, name: nameUser
        }
    });

    return response;

}


// função para export as ordens
const ManagersOrdersExport = async (number: number, costCenter: number, date: string, status: number) => {

    const response = await api.get('managers/orders/exportrdi', { params: { number, costCenter, date, status } });

    return response;


}



// função para pesquisar as ordens

// função para pesquisar dados de uma ordem
const ManagersShowOrderService = async (id: number) => {

    const response = await api.get(`managers/orders/${id}`);

    return response;

}
// função para pesquisar dados de uma ordem

const ManagersUpdateCostCenterService = async (id: number, costCenter: number) => {

    const response = await api.put(`managers/orders/updateCostCenter/${id}`, {
        cost_center: costCenter
    });

    return response;

}

export {
    ManagersOrdersService,
    ManagersShowOrderService,
    ManagersUpdateCostCenterService,
    ManagersOrdersExport
}